<script setup>
// import {ref} from "vue";
import CsaContact from "@/components/CsaContact.vue";
import CsaRibbon from "@/components/CsaRibbon.vue";
import {getCurrentInstance, onMounted, ref} from "vue";

const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const headerData = ref({})
onMounted(()=>{
  $axios.get($endpoint.LoadHeader).then((resp_header_data)=>{
    console.warn(resp_header_data.data);
    headerData.value = resp_header_data.data;
  })
}
);
const activeLink = ref(0)
</script>

<template>
  <!-- HEADER -->
  <header id="impx-header">
    <div>
      <div class="impx-menu-wrapper style2"
           data-uk-sticky="top: .impx-slide-container; animation: uk-animation-slide-top">

        <!-- Mobile Nav Start -->
        <div id="mobile-nav" data-uk-offcanvas="mode: push; overlay: true">
          <div class="uk-offcanvas-bar">

            <ul class="uk-nav uk-nav-default">

              <li :key="index" v-for="(item, index) in headerData.items"
                  :class="index ===0 ? 'uk-parent uk-active':'uk-parent'" >
                <router-link :to="item.url">{{item.title}}</router-link>
              </li>
            </ul>

          </div>
        </div>
        <a href="#mobile-nav" class="uk-hidden@xl uk-hidden@l uk-hidden@m mobile-nav"
           data-uk-toggle="target: #mobile-nav"><i class="fa fa-bars"></i>Menu</a>
        <!-- Mobile Nav End -->

        <!-- Top Header -->
        <div class="impx-top-header style2">
          <div class="uk-container uk-container-expand">
            <CsaContact :contact-infos="headerData?.topBar"></CsaContact>
          </div>
        </div>
        <!-- Top Header End -->


        <div class="uk-container uk-container-expand">
          <div data-uk-grid>

            <!-- Header Logo -->
            <div class="uk-width-auto">
              <div class="impx-logo">
                <a href="/"><img :src="headerData.logo?.url??''" class="logo_img" alt="Logo"></a>
              </div>
            </div>
            <!-- Header Logo End-->

            <!-- Header Navigation -->
            <div class="uk-width-expand uk-position-relative">

              <nav class="uk-navbar-container uk-navbar-transparent uk-visible@s uk-visible@m" data-uk-navbar>
                <div class="uk-navbar-right impx-navbar-right">
                  <ul class="uk-navbar-nav impx-nav style2">
                    <!-- Navigation Items -->
                    <li :key="index" v-for="(item, index) in headerData.items"
                        :class="activeLink ===index ? 'uk-parent uk-active':''" @click="activeLink = index">
                      <router-link class="uk-navbar-nav-subtitle" :to="item.url">
                          <div>{{ item.title }}
                            <div class="uk-navbar-subtitle">{{ item.subtitle }}</div>
                          </div>
                      </router-link>
                    </li>
                  </ul>
                  <!-- Navigation Items End -->
                </div>
              </nav>
            </div>
            <!-- Header Navigation End -->

            <!-- Promo Ribbon -->
            <CsaRibbon></CsaRibbon>
            <!-- Promo Ribbon End -->

          </div>
        </div>
      </div>
    </div>

  </header>
  <!-- HEADER END -->

</template>

<style scoped>

</style>